// extracted by mini-css-extract-plugin
export default {"list_row":"PoliceReportWorkQLoading_list_row__ybmtz","details_panel":"PoliceReportWorkQLoading_details_panel__t-BPx"};